export default "__VITE_PUBLIC_ASSET__bb4d5d11__"